import { useTranslation } from "react-i18next";
import type { CorpusSummary } from "../../../api/content/corporaApi";
import FieldGroup from "../../../ui/forms/FieldGroup";
import OptionLabel from "../../../ui/forms/OptionLabel";
import { useCorpusSelection } from "./corpusSelectionContext";

/** Which corpora the Documents sidebar lists and loads (F20); a choice only when there are several. */
export default function ShownCorporaChoice({ corpora }: { corpora: readonly CorpusSummary[] }) {
  const { t } = useTranslation();
  const { hiddenCorpusIds, showCorpus } = useCorpusSelection();

  if (corpora.length < 2) {
    return null;
  }
  return (
    <FieldGroup legend={t("sources.corpus.shown")} className="px-1">
      {corpora.map((corpus) => (
        <OptionLabel key={corpus.corpusId} size="small">
          <input type="checkbox" checked={!hiddenCorpusIds.has(corpus.corpusId)}
            onChange={(event) => { showCorpus(corpus.corpusId, event.target.checked); }} />
          <span className="truncate">{corpus.name}</span>
        </OptionLabel>
      ))}
    </FieldGroup>
  );
}
